export enum FeatureFlag {
  AnalyticsPlanningAssistant = 'analytics.planningAssistant',
  AnalyticsBetaReports = 'analytics.betaReports',
  Allocations = 'allocations',
  ReplenshimentProactiveInsights = 'replenshiment.proactiveInsights',
  HomePage = 'homePage',
  InventoryProductLocations = 'inventory.productLocations',
  DataCenterUploads = 'dataCenter.uploads',
  AssortmentAllocations = 'assortmentAllocations',
  DataTableRowActions = 'dataTableRowActions',
  StoreTransferOperationalConstraints = 'storeTransfer.operationalConstraints',
  PandaPlus = 'pandaPlus',
  ShipmentDays = 'inventory.shipmentDays',
  LocationActivityStatus = 'inventory.locationActivityStatus',
  InventoryManagement = 'inventoryManagement',
  OneBee = 'oneBee',
  SpecialEventsElephantV2 = 'specialEvents.elephantV2',
}
